import landingPageModule from "../landingPageModule"


function landingPageContainer(landingPageConstants) {
    "ngInject";

    return {
        restrict: "A",
        replace: false,
        templateUrl: landingPageConstants.templates.landingPage,
        controller: "landingPageController",
        link: function link(scope, element, attrs) {
            scope.landingParams = {
                isLoginFunCaptchaEnabled: attrs.isLoginFunCaptchaEnabled === 'true',
                isAlwaysCaptchaLoginEnabled: attrs.isAlwaysCaptchaLoginEnabled === 'true',
                isAlwaysCaptchaSignupEnabled: attrs.isAlwaysCaptchaSignupEnabled === 'true',
                isCaptchaV2ComponentForSignupEnabled: attrs.isCaptchaV2ComponentForSignupEnabled === 'true',
                isBedev2CaptchaForWebLoginEnabled: attrs.isBedev2CaptchaForWebLoginEnabled === 'true'
            };
        },
        scope: {
            abTestVariation: '=',
            ftuxAvatarVersion: '=',
            ftuxContextVersion: '=',
            isFtuxAvatarEnabled: '=',
            useExperimentationPlatformForFtux: '='
        }
    }
}
landingPageModule.directive("landingPageContainer", landingPageContainer);

export default landingPageModule;